import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入新的 JSON 翻译文件
import enBase from './locales/en/base.json';
import enActivity from './locales/en/activity.json';
import enEducation from './locales/en/education.json';
import enOpenAccount from './locales/en/open_account.json';
import enSubscribtion from './locales/en/subscribtion.json';

import viBase from './locales/vi/base.json';
import viActivity from './locales/vi/activity.json';
import viEducation from './locales/vi/education.json';
import viOpenAccount from './locales/vi/open_account.json';
import viSubscribtion from './locales/vi/subscribtion.json';

import idBase from './locales/id/base.json';
import idActivity from './locales/id/activity.json';
import idEducation from './locales/id/education.json';
import idOpenAccount from './locales/id/open_account.json';
import idSubscribtion from './locales/id/subscribtion.json';

// 默认语言
const defaultLng = 'en';

// 字体路径映射（使用动态导入，按需加载）
const languageToFontLoader: Record<string, () => Promise<string>> = {
  'en': () => import('@/assets/fonts/AlibabaPuHuiTi/AlibabaPuHuiTi-En.woff2').then(m => m.default),
  'en-US': () => import('@/assets/fonts/AlibabaPuHuiTi/AlibabaPuHuiTi-En.woff2').then(m => m.default),
  'vi-VN': () => import('@/assets/fonts/AlibabaPuHuiTi/AlibabaPuHuiTi-VN.woff2').then(m => m.default),
  'id-ID': () => import('@/assets/fonts/AlibabaPuHuiTi/AlibabaPuHuiTi-ID.woff2').then(m => m.default),
};

// 动态加载字体
const loadFontForLanguage = async (lng: string) => {
  if (typeof document === 'undefined') return;

  const fontLoader = languageToFontLoader[lng] || languageToFontLoader['en'];

  try {
    const fontUrl = await fontLoader();
    const styleId = 'dynamic-font-face';

    // 移除旧的字体样式
    const existingStyle = document.getElementById(styleId);
    if (existingStyle) {
      existingStyle.remove();
    }

    // 创建新的 @font-face 规则
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @font-face {
        font-family: 'Alibaba PuHuiTi 3.0';
        src: url('${fontUrl}');
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
  } catch (error) {
    console.error('Failed to load font for language:', lng, error);
  }
};

// 设置文档语言属性
const setDocumentLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng);
    document.documentElement.setAttribute('data-lang', lng);
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        base: enBase,
        activity: enActivity,
        education: enEducation,
        openAccount: enOpenAccount,
        subscribtion: enSubscribtion,
      },
      'en-US': {
        base: enBase,
        activity: enActivity,
        education: enEducation,
        openAccount: enOpenAccount,
        subscribtion: enSubscribtion,
      },
      'vi-VN': {
        base: viBase,
        activity: viActivity,
        education: viEducation,
        openAccount: viOpenAccount,
        subscribtion: viSubscribtion,
      },
      'id-ID': {
        base: idBase,
        activity: idActivity,
        education: idEducation,
        openAccount: idOpenAccount,
        subscribtion: idSubscribtion,
      },
    },
    lng: defaultLng,
    fallbackLng: 'en',
    ns: ['base', 'activity', 'education', 'openAccount', 'subscribtion'],
    defaultNS: 'base',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

// 初始化（同时加载默认语言的字体）
setDocumentLang(defaultLng);
loadFontForLanguage(defaultLng);

// 监听语言变化（字体在这里加载）
i18n.on('languageChanged', (lng) => {
  setDocumentLang(lng);
  loadFontForLanguage(lng);
});

export default i18n;
